import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import type { Channel } from "@/api_client";
import { FeatureFlagsProvider } from "@/feature_toggling/FeatureFlagsProvider";
import { WebComponentRuntimeProvider } from "./webComponentRuntimeContext";

interface WrapperProps {
  children?: React.ReactNode;
  backendHost?: string;
  appPathPrefix?: string;
  skipCart?: boolean;
  channel?: Channel;
  language?: string;
}

export const webComponentQueryClient = new QueryClient();

export default function Wrapper({
  children,
  backendHost,
  appPathPrefix,
  skipCart = false,
  channel,
  language,
}: Readonly<WrapperProps>) {
  return (
    <React.StrictMode>
      <FeatureFlagsProvider
        flags={{
          enableInputAutoComplete: false,
        }}
      >
        <WebComponentRuntimeProvider
          backendHost={backendHost}
          appPathPrefix={appPathPrefix}
          skipCart={skipCart}
          channel={channel}
          language={language}
        >
          <QueryClientProvider client={webComponentQueryClient}>
            {children}
          </QueryClientProvider>
        </WebComponentRuntimeProvider>
      </FeatureFlagsProvider>
    </React.StrictMode>
  );
}
